import { render } from "./CreateCasino.vue?vue&type=template&id=d25d9a64&scoped=true"
import script from "./CreateCasino.vue?vue&type=script&lang=js"
export * from "./CreateCasino.vue?vue&type=script&lang=js"

import "./CreateCasino.vue?vue&type=style&index=0&id=d25d9a64&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d25d9a64"]])

export default __exports__